//  See https://vuejs.org/v2/guide/plugins.html
export default {
  install(Vue, options) {
    // 1. add global method or property
    Vue.prototype.$getRouterLinkWithLocale = function(to) {
      // some logic ...
      return "/" + options.i18n.locale + to;
    };
  }
};
